import React, { useState } from "react";
import { X, CheckCircle } from "lucide-react";
import {
  useGetSensorsQuery,
  useAssignSensorMutation,
} from "../../redux/logistics/logisticsApi";

import "./sensorassignmodal.css";

export default function SensorAssignModal({
  device,
  onClose,
}) {
  const { data, isLoading } = useGetSensorsQuery();
  const [assignSensor] = useAssignSensorMutation();
  const [selectedSensors, setSelectedSensors] = useState([]);

  const sensors = Array.isArray(data) ? data : data?.data || [];

  const toggleSensor = (sensorId) => {
    setSelectedSensors((prev) =>
      prev.includes(sensorId)
        ? prev.filter((id) => id !== sensorId)
        : [...prev, sensorId]
    );
  };

  const handleAssign = async () => {
    try {
      for (const sensorId of selectedSensors) {
        await assignSensor({
          sensorId,
          deviceId: device._id,
        }).unwrap();
      }
      onClose();
    } catch (err) {
      console.error("Sensor assign failed", err);
    }
  };

  return (
    <div className="sensor-modal-backdrop">
      <div className="sensor-modal">
        <div className="sensor-modal-header">
          <h3>Assign Sensors to {device.name}</h3>
          <button onClick={onClose}><X size={18} /></button>
        </div>

        <div className="sensor-modal-body">
          {isLoading ? (
            <p>Loading sensors...</p>
          ) : sensors.length === 0 ? (
            <p>No sensors available</p>
          ) : (
            sensors.map((sensor) => (
              <label key={sensor._id} className="sensor-row">
                <input
                  type="checkbox"
                  checked={selectedSensors.includes(sensor._id)}
                disabled={sensor.assignedToDevice}
                  onChange={() => toggleSensor(sensor._id)}
                />
                <div>
                  <strong>{sensor.name}</strong>
                  <span className="sensor-type">{sensor.type}</span>
                  {sensor.assignedToDevice && (
                    <span className="sensor-assigned">
                      Assigned
                    </span>
                  )}
                </div>
              </label>
            ))
          )}
        </div>

        <div className="sensor-modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary"
            disabled={!selectedSensors.length}
            onClick={handleAssign}
          >
            <CheckCircle size={16} /> Assign Selected
          </button>
        </div>
      </div>
    </div>
  );
}
